import styles from "./styles.module.scss";

const appleImg = "/roadsync/applestore.png";
const googleImg = "/roadsync/googleplay.png";
const logoImg = "/roadsync/logo-roadsync.png";

export default function Banner() {
	return (
		<div className={styles.bannerContainer}>
			<div className={`customContainer ${styles.container}`}>
				<img width={672} alt="Honda Roadsync" height={238} src={logoImg} className={styles.logo} />
				<div className={styles.ctaButtons}>
					<a href="https://apps.apple.com/in/app/honda-roadsync/id1575345943" target="_blank" className="">
						Download for Apple
					</a>
					<a href="https://play.google.com/store/apps/details?id=com.honda.ms.dm.sab" target="_blank" className="">
						Download for Android
					</a>
				</div>
				<div className={styles.storeButtons}>
					<a href="https://play.google.com/store/apps/details?id=com.honda.ms.dm.sab" target="_blank">
						<img width={181} height={54} src={googleImg} />
					</a>
					<a href="https://apps.apple.com/in/app/honda-roadsync/id1575345943" target="_blank">
						<img width={160} height={54} src={appleImg} />
					</a>
				</div>

			</div>
		</div>
	);
}